import { defineMessages } from 'react-intl';

/**
 * Every string of the Social block of the artist Home (design: music24-social-connectors d).
 *
 * The native apps read these ids too, so keep the ids stable. The period is 28 days on paid plans
 * and on the trial, and 7 days on Free.
 */
export const socialBlockMessages = defineMessages({
  title: { id: 'app.sml.artistHome.social.title', defaultMessage: 'Social' },
  open: { id: 'app.sml.artistHome.social.openSocial', defaultMessage: 'Open Social' },
  followersPeriod: {
    id: 'app.sml.artistHome.social.followersPeriod',
    defaultMessage: 'Followers · last {days} days',
  },
  followers: { id: 'app.sml.artistHome.social.followers', defaultMessage: 'Followers' },
  subscribers: { id: 'app.sml.artistHome.social.subscribers', defaultMessage: 'Subscribers' },
  reading: { id: 'app.sml.artistHome.social.reading', defaultMessage: 'Reading your numbers' },
  reconnect: { id: 'app.sml.artistHome.social.reconnect', defaultMessage: 'Reconnect' },
  // The flat pill draws the dash before the text: "— first week".
  firstWeek: { id: 'app.sml.artistHome.social.firstWeek', defaultMessage: 'first week' },

  bestPostPeriod: {
    id: 'app.sml.artistHome.social.bestPost.period',
    defaultMessage: 'Best post · last {days} days',
  },
  bestPostViews: {
    id: 'app.sml.artistHome.social.bestPost.views',
    defaultMessage: '{count, plural, one {# view} other {# views}}',
  },
  bestPostLikes: {
    id: 'app.sml.artistHome.social.bestPost.likes',
    defaultMessage: '{count, plural, one {# like} other {# likes}}',
  },
  bestPostComments: {
    id: 'app.sml.artistHome.social.bestPost.comments',
    defaultMessage: '{count, plural, one {# comment} other {# comments}}',
  },
  bestPostEmpty: {
    id: 'app.sml.artistHome.social.bestPost.empty',
    defaultMessage: 'No post in the last {days} days. Publish one and its numbers show here.',
  },
  bestPostOpenComposer: {
    id: 'app.sml.artistHome.social.bestPost.openComposer',
    defaultMessage: 'Open Composer',
  },

  typeReel: { id: 'app.sml.artistHome.social.type.reel', defaultMessage: 'Reel' },
  typeShort: { id: 'app.sml.artistHome.social.type.short', defaultMessage: 'Short' },
  typeVideo: { id: 'app.sml.artistHome.social.type.video', defaultMessage: 'Video' },
  typePhoto: { id: 'app.sml.artistHome.social.type.photo', defaultMessage: 'Photo' },
  typeCarousel: { id: 'app.sml.artistHome.social.type.carousel', defaultMessage: 'Carousel' },
  typeText: { id: 'app.sml.artistHome.social.type.text', defaultMessage: 'Text' },
  typeStory: { id: 'app.sml.artistHome.social.type.story', defaultMessage: 'Story' },

  emptyTitle: { id: 'app.sml.artistHome.social.empty.title', defaultMessage: 'Connect your channels' },
  emptyBody: {
    id: 'app.sml.artistHome.social.empty.body',
    defaultMessage:
      'Connect TikTok, Instagram, YouTube, Facebook, Threads or X. Home then shows your followers and your best post.',
  },
  emptyCta: { id: 'app.sml.artistHome.social.empty.cta', defaultMessage: 'Connect a channel' },
});
